import {
    AfterViewInit,
    Component,
    ElementRef,
    Input, OnChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { Capacitor } from '@capacitor/core';
import SewingPatternInterface from '../../../../models/sewing-pattern.interface';
import {PatternRepository} from '../../../../repositories/pattern.repository';
import {PatternTransformService} from '../../../../services/pattern/pattern-transform.service';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {ConfiguratorService} from '../../../../services/configurator/configurator.service';
import SewingPatternProject from '../../../../models/sewing-pattern-project.model';
import {ViewDidEnter} from '@ionic/angular';
import {PatternShareService} from "../../../../services/pattern/pattern-share.service";

@Component({
    selector: 'app-pattern-preview',
    templateUrl: './pattern-preview.component.html',
    styleUrls: ['./pattern-preview.component.css']
})
export class PatternPreviewComponent implements AfterViewInit, OnChanges {
    @ViewChild('image') image: ElementRef<HTMLElement>;

    @Input() transparent = false;
    @Input() showShadow = false;

    @Input() sewingPatternSVG: string;
    @Input() sewingPatternProject: SewingPatternProject;

    public url: string;
    public sewingPatternSVGImage: SafeUrl;

    // tslint:disable-next-line:variable-name
    private _sewingPattern: SewingPatternInterface;

    get sewingPattern() {
        return this._sewingPattern;
    }

    @Input()
    set sewingPattern(value) {
        this._sewingPattern = value;
    }

    get requiredMaterials() {
        if (!this.sewingPattern) {
            return [];
        }

        return [...new Set(this.sewingPattern.areas.map(area => area.fabric).filter(material => !!material))];
    }

    constructor(private sewingPatternRepository: PatternRepository,
                private patternTransformService: PatternTransformService,
                private patternShareService: PatternShareService,
                private configuratorService: ConfiguratorService,
                private domSanitizer: DomSanitizer) {
    }

    async prepareSVG(patternSVG) {
    }

    async loadSVG() {
        if (this.sewingPatternSVG) {
            const base64 = btoa(this.sewingPatternSVG);
            this.sewingPatternSVGImage = this.domSanitizer.bypassSecurityTrustUrl(`data:image/svg+xml;base64,${base64}`);
        }


        if (this.sewingPatternProject) {
            this.sewingPatternSVGImage = this.sewingPatternProject.url;
        }
    }

    ngAfterViewInit() {
        this.loadSVG();
    }

    async ngOnChanges() {
        await this.loadSVG();
    }
}
